module.exports = __webpack_public_path__ + "static/home-ftp1-663f71d80979712d1008ab1dbc52ae95.png";